import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Dropdown } from "../../../../components/dropdown/Dropdown";
import { Button } from "../../../../components/button/Button";
import { Icon } from "../../../../components/icon/Icon";
import { generateDeeplink } from "../../../../components/deeplinkDialog/deeplinkDialog.actions";
import { openAddDeviceModal } from "../addDevice/AddDevice";
import { isAddDeviceDisabled } from "../../../../store/profiles/profiles.selectors";
import { FormattedMessage } from "react-intl";

import "./ManageDevices.scss";

export const ManageDevices = () => {
  const dispatch = useDispatch();
  const isDisabled = useSelector(isAddDeviceDisabled);

  const handleAddDevice = () => {
    dispatch(openAddDeviceModal());
  };

  const handleGenerateLink = () => {
    dispatch(generateDeeplink());
  };

  const manageDeviceList = [
    {
      id: "manage-add-device",
      classname: "manage-add-device",
      disabled: isDisabled,
      content: (
        <div className="manage-add-device__button">
          <Icon icon="fa-regular fa-plus" />
          <span>
            <FormattedMessage id="add_device" />
          </span>
        </div>
      ),
      action: handleAddDevice,
    },
    {
      id: "manage-invite-remote-device",
      classname: "manage-invite-remote-device",
      content: (
        <div>
          <Icon icon="fa-regular fa-link" />
          <span>
            <FormattedMessage id="invite_remote_device" />
          </span>
        </div>
      ),
      action: handleGenerateLink,
    },
  ];

  return (
    <Dropdown
      items={manageDeviceList}
      className="manage-device"
      toggleButton={
        <Button color="secondary">
          <span>
            <FormattedMessage id="manage_devices" />
          </span>
          <Icon icon="fa-regular fa-solid fa-caret-down" />
        </Button>
      }
    />
  );
};
